import { createSlotRecipeContext, HTMLChakraProps, RecipeVariantProps } from '@chakra-ui/react';
import { Body } from '@components/ui/draggable/Body';
import { MotionBox } from '@components/ui/draggable/DraggableBox';
import { Footer } from '@components/ui/draggable/Footer';
import { Header } from '@components/ui/draggable/Header';
import { draggablePanelSlotRecipe } from '@theme/component';
import { ReactNode, RefObject } from 'react';

import { Root } from './Root';

export type DraggablePanelVariantProps = RecipeVariantProps<typeof draggablePanelSlotRecipe>;

const { withProvider, withContext } = createSlotRecipeContext({ key: 'draggablePanel' });

export type DraggablePanelRootProps = Omit<HTMLChakraProps<typeof MotionBox>, 'top' | 'left'> & {
  top: number;
  left: number;
  children: ReactNode;
  constraintsRef?: RefObject<HTMLDivElement | null>;
  offsetX?: number;
  offsetY?: number;
} & DraggablePanelVariantProps;

export const DraggablePanelRoot = withProvider<HTMLDivElement, DraggablePanelRootProps>(Root, 'root', {
  forwardAsChild: true,
});

export type DraggablePanelHeaderProps = HTMLChakraProps<'div'> & {
  children: ReactNode;
  onClose?: () => void;
} & DraggablePanelVariantProps;
export const DraggablePanelHeader = withContext<HTMLDivElement, DraggablePanelHeaderProps>(Header, 'header');

export type DraggablePanelBodyProps = HTMLChakraProps<'div'> & {
  children: ReactNode;
  height?: number;
  minHeight?: number;
  maxHeight?: number;
} & DraggablePanelVariantProps;
export const DraggablePanelBody = withContext<HTMLDivElement, DraggablePanelBodyProps>(Body, 'body');

export type DraggablePanelFooterProps = HTMLChakraProps<'div'> & {
  children: ReactNode;
} & DraggablePanelVariantProps;
export const DraggablePanelFooter = withContext<HTMLDivElement, DraggablePanelFooterProps>(Footer, 'footer');
